import React from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import { apiGet, apiPost } from '../../../services/apiClient';
import { getRoles } from '../../../services/userRights';
import Grid from '../../../grid/grid.jsx';
import Forbidden from '../../forbidden/forbidden.jsx';

export default class AdminCompaniesTable extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            busyCount: 0,
            disableFilters: false,
            lastResponseError: null,
            columns: [
                {
                    title: 'Юр. лицо клиента',
                    fieldName: 'name',
                    filterType: 'string',
                    minWidth: 140
                },
	            {
                    title: 'Юр. лицо US',
                    fieldName: 'companyUsName',
                    filterType: 'dropdown',
                    loadUrl: 'admin/companies/ref/companiesus',
		            minWidth: 140
	            },
                {
                    title: 'Транспортные компании',
                    fieldName: 'carrierList',
                    filterType: 'dropdown',
                    loadUrl: 'admin/companies/ref/carriers',
                    minWidth: 150
                },
                {
                    title: 'Комментарий',
                    fieldName: 'comment',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'ИНН',
                    fieldName: 'inn',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Страхование',
                    fieldName: 'isInsuranceRequired',
                    filterType: 'boolean',
                    minWidth: 130
                },
                {
                    title: 'Клиентский менеджер',
                    fieldName: 'clientManagerName',
                    filterType: 'dropdown',
                    loadUrl: 'admin/companies/ref/clientManagers',
                    minWidth: 160
                },
                {
                    title: 'Инициатор создания',
                    fieldName: 'creator',
                    filterType: 'string',
                    minWidth: 160
                },
                {
                    title: 'Дата создания',
                    fieldName: 'creationDate',
                    filterType: 'date',
                    minWidth: 140
                },
                {
                    title: 'Плата за пользование своим перевозчиком, р. с НДС',
                    fieldName: 'feeUsingYourCarrier',
                    filterType: 'number',
                    minWidth: 250
                },
                {
                    title: 'Стоимость создания заказа клиентским менеджером р. с НДС',
                    fieldName: 'createByManagerCost',
                    filterType: 'number',
                    minWidth: 250
                },
                {
                    title: 'Статус договора',
                    fieldName: 'contractStatus',
                    filterType: 'dropdown',
                    loadUrl: 'admin/companies/ref/contractStatuses',
                    minWidth: 130
                },
                {
                    title: 'Срок действия договора',
                    fieldName: 'contractExpireDate',
                    filterType: 'date',
                    minWidth: 140
                },
                {
                    title: 'Дней отсрочки платежа от даты счёта',
                    fieldName: 'defermentDaysCount',
                    filterType: 'number',
                    minWidth: 250
                },
                {
                    title: 'Рабочих дней отсрочки?',
                    fieldName: 'isDefermentWorkDays',
                    filterType: 'boolean',
                    minWidth: 130
                }
            ]
        };
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    addNew() {
        this.props.history.push('/admin/companies/new');
    }

    loadData(settings, takeCount, skipCount, needOverlay) {
        this.updateBusyCount(needOverlay ? 1 : 0);
        return apiPost('admin/companies/list', { settings: settings, takeCount, skipCount })
            .then(data => {
                this.updateBusyCount(needOverlay ? -1 : 0);
                return data.entries;
            })
            .catch(err => {
                this.updateBusyCount(needOverlay ? -1 : 0);
                if (err.status > 401) {
                    this.setState({ lastResponseError: err.status });
                }
            });
    }

    downloadExcel() {
        this.updateBusyCount(1);
        let settings = this.grid.getSettings();
        apiPost('admin/companies/excel', { settings: settings })
            .then(data => {
                this.updateBusyCount(-1);
                let fileUrl = getApiBaseUrl() + 'files/' + data.result;
                window.location.href = fileUrl;
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    renderCellValue(row, column) {
        switch (column.fieldName) {
            case 'name':
                var adminUserLink = "/admin/companies/" + row.id;
                return <NavLink to={adminUserLink}>{row.name}</NavLink>;
            case 'isActive':
                return row[column.fieldName] ? "Активный" : "Не активный";
            case 'isInsuranceRequired':
                return row[column.fieldName] ? "Обязательно" : "Не обязательно";
            case 'isDefermentWorkDays':
                return row[column.fieldName] !== undefined && row[column.fieldName] !== null && (row[column.fieldName] ? "рабочих дней" : "календарных дней");
            case 'creationDate':
                return row.creationDate && moment(row.creationDate).format("DD.MM.YYYY HH:mm");
            case 'contractExpireDate':
                return row.contractExpireDate && moment(row.contractExpireDate).format("DD.MM.YYYY");
    
            default:
                return row[column.fieldName];
        }
    }

    render() {
        let roles = getRoles();
        let hasAccess = roles.includes('Admin') || roles.includes('GlobalAdmin') || roles.includes('Financial');
        if (!hasAccess || this.state.lastResponseError === 403) {
            return <Forbidden />;
        }

        let isBusy = this.state.busyCount > 0;

        return (
            <div>
                <section className="content-header">
                    <h1>
                        Юр. лица клиентов
                    </h1>
                    <ol className="breadcrumb">
                        <li><a><i className="fa fa-cogs"></i> Администрирование</a></li>
                        <li className="active">Юр. лица клиентов</li>
                    </ol>
                </section>
                <section className="content">
                    <div className="box grid-box" style={{ height: this.state.boxHeight }}>
                        <div className="box-header">
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.grid.reload()}
                                    disabled={isBusy}
                                >
                                    <span className="fa fa-refresh"></span> Обновить
                                </a>
                            </div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.grid.clearSettings()}
                                    disabled={isBusy}
                                >
                                    <span className="glyphicon glyphicon-remove"></span> Сбросить
                                </a>
                            </div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.downloadExcel()}
                                    disabled={isBusy}
                                >
                                    <span className="glyphicon glyphicon-save-file"></span> Excel
                                </a>
                            </div>
                            <div className="btn-group btn-tool">
                                <a className="btn btn-flat btn-default btn-sm"
                                    onClick={() => this.addNew()}
                                    disabled={isBusy}
                                >
                                    <span className="fa fa-plus"></span> Добавить новое юр.лицо
                                </a>
                            </div>
                        </div>
                        <div className="box-body">
                            <Grid columns={this.state.columns}
                                loadData={(settings, take, skip, needOverlay) => this.loadData(settings, take, skip, needOverlay)}
                                isBusy={isBusy}
                                disableFilters={this.state.disableFilters}
                                gridKey="admin-companies"
                                renderCellValue={(row, column) => this.renderCellValue(row, column)}
                                ref={grid => this.grid = grid}
                            />
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/admin/companies/companiesTable.jsx